import fetchApi from "../fetchApi";
export const UpdateReport = async (id, email, report, frequency, timeRange, method) => {

    const options = {
        method: 'PUT',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            "email": email,
            "report": report,
            "frequency": frequency,
            "time_range": timeRange,
            "reporting_method": method
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/company/report/${id}`, options);
};